import React, { useEffect } from "react";
import SBox from '../../Basicos/LVSelectBoxConList';
import { useState } from 'react';
import { function_ABM_TRA_EmpresasTransporteLocaciones_Listar } from "neftis7_apicaller/src/funciones/ABM/TRA/ABM_TRA_EmpresasTransporteLocaciones";

function ComboAbmTraEmpresasTransporteLocaciones({ onValueChanged, value, visible = true, reloadData, ancho = "100%", CodigoEmpresaTransporte }) {
  const [loading, setLoading] = useState(true)
  const [data, setData] = useState([])
  const [selectedValue, setSelectedValue] = useState(value || "");

  const getData = async () => {
    // Llama a función asíncrona y maneja los datos
    try {
      const resultData = await function_ABM_TRA_EmpresasTransporteLocaciones_Listar(CodigoEmpresaTransporte)

      setData(resultData.data)
    } catch (error) {
      alert("Error al obtener los datos: " + error);
    }
    setLoading(false)
  };

  useEffect(() => {
    setSelectedValue("")
    getData();
  }, []);

  useEffect(() => {
    if (data.length > 0) {
      // Si vino un valor desde afuera -> lo pongo
      if (value) {
        setSelectedValue(value);
      }
      // Si no vino valor pero hay un solo registro -> lo pongo
      else if (data.length === 1) {
        setSelectedValue(data[0].CodigoLocacionEmpresaTransporte);
        if (onValueChanged) {
          onValueChanged({ value: data[0].CodigoLocacionEmpresaTransporte });
        }
      }
    }
  }, [data, value]);

  useEffect(() => {
    setSelectedValue("");
    getData();
  }, [CodigoEmpresaTransporte]);

  return (
    <SBox
      textoLabel=""
      textoSelectBox="Seleccionar Locacion"
      data={data}
      campoCodigo="CodigoLocacionEmpresaTransporte"
      campoDescripcion="Descripcion"
      ancho={ancho}
      onValueChanged={onValueChanged}
      value={selectedValue}
      visible={visible}
      isLoading={loading}
    />
  );
}

export default ComboAbmTraEmpresasTransporteLocaciones

